import { Component } from '@angular/core';
import { IFloatingFilter } from 'ag-grid-community';

@Component({
   selector: 'app-refresh-grid',
   templateUrl: './refresh-grid.component.html',
   styleUrls: ['./refresh-grid.component.scss']
})
export class RefreshGridComponent implements IFloatingFilter {
   params: any;
   constructor() { }
   onParentModelChanged(): void {
      // Need to write Logic
   }

   agInit(params: any): void { this.params = params; }
   resetFilters() { this.params.api.setFilterModel(null); }

}
